import styled from 'styled-components'

export const StyledLatestMain = styled.main`
  min-height: 100vh;
  min-width: 100vw;
  background: ${({ theme }) => theme.colors.brand.backgroundPrimary};
`
